const U = (id, w = 1200) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMG = {
  hero: U("1706820229870-f9a8c6dac193", 1920),
  diningTable: U("1704040686487-a39bb894fc93"),
  kitchen: U("1682888813913-e13f18692019"),
  marble: U("1610276099118-c929abaaa80a"),
  sofa: U("1758448755778-90ebf4d0f1e7"),
  velvetSofa: "https://images.pexels.com/photos/6312016/pexels-photo-6312016.jpeg?auto=compress&cs=tinysrgb&w=1200",
  furniture: U("1606744888344-493238951221"),
  curtains: U("1773855742899-f0d9803695f8"),
  rug: U("1761039265583-9489b4246454"),
  glass: U("1778731525567-a65ec40a4bb5"),
  livingCTA: "https://images.pexels.com/photos/8135267/pexels-photo-8135267.jpeg?auto=compress&cs=tinysrgb&w=1600",
  proj1: U("1706820229870-f9a8c6dac193"),
  proj2: U("1611095210561-67f0832b1ca3"),
  proj3: U("1780257562963-3389a4105371"),
  proj4: U("1696413542101-2479dd479982"),
};
